"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
/**
 * Switch order item between course.
 * if courseId is undefined mean the item will belong to default course name NOW
 * @param event of switch course Event
 * @param prevState
 */
function default_1(event, prevState) {
    const order = prevState;
    if (!(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    const orderItems = order.orderItems || [];
    const comboItems = (0, utils_1.getComboItems)(orderItems);
    [...orderItems, ...comboItems].forEach(item => {
        if (item.id === event.orderItemId)
            item.course = {
                id: event.courseId,
                ...(event.courseId && event.courseName && { name: event.courseName }),
            };
    });
    order.orderItems = (0, utils_1.mergeIdenticalOrderItems)(order.orderItems);
    return order;
}
exports.default = default_1;
//# sourceMappingURL=switchCourseItem.js.map